import { Component, OnInit } from '@angular/core';
import { FormDataFacade } from 'src/app/ngrx/form-data/form-data.facade';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { PleaseWaitModalComponent } from 'src/app/shared/please-wait-modal/please-wait-modal.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal/';
import * as moment from 'moment';
import { ErrorModalComponent } from 'src/app/shared/error-modal/error-modal.component';

@Component({
  selector: 'app-add-new-assessment-modal',
  templateUrl: './add-new-assessment-modal.component.html',
  styleUrls: ['./add-new-assessment-modal.component.scss']
})
export class AddNewAssessmentModalComponent implements OnInit {

  assessmentData = [];
  assessmentListData = [];
  dateToday = moment(new Date()).format('MM/DD/YYYY');
  formValue = "";
  typeValue = "";
  assessmentDate = moment(new Date()).format('MM/DD/YYYY');

  constructor(
    private fdFacade: FormDataFacade,
    private api: ApiService,
    private storage: StorageService,
    public bsModalRef: BsModalRef,
    private pleaseWaitModalRef: BsModalRef,
    private errorModalRef: BsModalRef,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.fdFacade.getSpecificValue('assessments').subscribe(
      data => {
        if (data !== undefined) {
          this.assessmentListData = [];
          this.assessmentData = [...data];
          Array.from(
            new Set(data.map(assessData => assessData.form).sort())
          ).map(
            formName => {
              const assessmentSpecificData = data.filter(
                assessData => assessData.form === formName
                        && (assessData.status === 'Draft' || assessData.status === 'Locked')
                        && (assessData.json_data !== undefined && assessData.json_data !== null)
              ).sort(
                (a, b) => (a.cycle < b.cycle) ? 1 : ((b.cycle < a.cycle) ? - 1 : 0)
              ).map(
                (assessData, x) => {
                  if (x === 0) {
                    return {
                      ...assessData
                    };
                  }
                  return assessData;
                }
              );
              this.assessmentListData = [
                ...this.assessmentListData,
                ...assessmentSpecificData
              ];
            }
          );
        }
      }
    );
  }

  submitAssessment() {
    this.pleaseWaitModalRef = this.modalService.show(PleaseWaitModalComponent);
    const apsReportLoadId = this.storage.getLocalValue('selectedID');
    const assignedAgentId = +this.storage.getLocalValue('selectedAssignedAgentId');
    const selectedCaseNumber = +this.storage.getSessionValue('selectedCaseNumber');
    let isError = false;
    console.log(this.api.getAssessmentStandAlonedata().getValue());
    const standaloneData = JSON.parse(this.api.getAssessmentStandAlonedata().getValue());
    const formattedPayload = {
      aps_case_load_id: selectedCaseNumber,
      assessment_cycle_evaluation_id: 0,
      assessment_date: this.assessmentDate,
      assessment_id: 0,
      form: this.formValue,
      has_change: true,
      last_edited_by: "",
      next_due_annual:"",
      participant_id: 0,
      status: "Draft",
      type: this.typeValue,
      update_date: this.dateToday,
      json_data: standaloneData,
      parentAssessment: false
    };
    this.assessmentData.map(
      assessData => {
        if (assessData.form === this.formValue) {
          if(assessData.status === 'Draft') {
            isError = true;
          } else {
            assessData.parentAssessment = false
            formattedPayload.parentAssessment = true;
          }
        }
        return assessData;
      }
    );
    if(isError) {
      setTimeout(() => {
        this.pleaseWaitModalRef.hide();
      }, 500);
      const initialState = {
        errorMsg: 'This assessment cannot be started as there is already one in progress.'
      };
      this.errorModalRef = this.modalService.show(ErrorModalComponent, {initialState});
    } else {
      isError = false;
      this.assessmentData.unshift(formattedPayload);
      this.api.setSelectedAssessmentOnAdd(formattedPayload);
      setTimeout(() => {
        this.fdFacade.updateDataToDB(
          +apsReportLoadId,
          +assignedAgentId,
          this.assessmentData,
          'assessments',
          true
        );
        this.pleaseWaitModalRef.hide();
        this.bsModalRef.hide();
      }, 500);
    }
  }

}
